import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/usuarios/usuarios-limitaciones-de-informacion/';

/**
 * GET Lista de Limitaciones de Información
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getUsuariosLimitaciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Limitación Individual
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getUsuarioLimitacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Crear Limitación
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postUsuarioLimitacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Editar Limitación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchUsuarioLimitacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Eliminar Limitación
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteUsuarioLimitacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
